// Shared builders for the game-service challenge accept/reject packets, mirroring
// ChallengeComponent.handleChallengeResponse so the in-chat club challenge card uses
// the exact same proven logic. Pure builders (no socket/navigation) so they're unit-
// testable; the caller does setLocalStorage + navigate + send_msg.

export type ResponsePacket = {
  requestId: string;
  type: "challenge_accept_response" | "challenge_reject";
  variantId: any;
  userId: string;
  opponent: any;
  playerMoveTimer: any;
  moveTimeIncrement: any;
  gameState: any;
  white: any;
  black: string;
  gamePlayMode: any;
};

const base = (data: any, username: string): Omit<ResponsePacket, "type"> => ({
  requestId: data.requestId || String(Date.now()),
  variantId: data.variantId,
  userId: username,
  opponent: data.opponent,
  playerMoveTimer: data.playerMoveTimer,
  moveTimeIncrement: data.moveTimeIncrement,
  gameState: data.gameState,
  white: data.white,
  black: "",
  gamePlayMode: data.gamePlayMode,
});

export const buildAcceptPacket = (data: any, username: string): ResponsePacket => ({
  ...base(data, username),
  type: "challenge_accept_response",
});

export const buildRejectPacket = (data: any, username: string): ResponsePacket => ({
  ...base(data, username),
  type: "challenge_reject",
});
